module.exports = __webpack_public_path__ + "media/images/icons/icons_large/72_bante-814286698f2d6ffab9dd63bba385e93b.png";